<template>
  <div
    class="
      py-3
      lg:py-4
      px-3
      lg:px-6
      bg-white-005
      rounded-2xl
      flex flex-col
      h-full
      flex-1
    "
  >
    <div class="text-sm lg:text-xl font-bold mb-6">
      Top DAOs Based on Governance
    </div>

    <div class="flex h-10 items-center text-white-070 text-xs lg:text-base">
      <div class="pl-1 lg:pl-2" style="width: 9%">#</div>
      <div class="pl-2" style="width: 36%">Name</div>
      <div class="pl-0 lg:pl-2" style="width: 24%">
        <Sort v-model="state.sortValue" index="0">Proposals</Sort>
      </div>
      <div class="pr-2 flex justify-end" style="width: 17%">
        <Sort v-model="state.sortValue" index="1"> Voters </Sort>
      </div>
      <div class="pr-2 flex justify-end" style="width: 15%">
        <Sort v-model="state.sortValue" index="2">Votes</Sort>
      </div>
    </div>

    <div class="flex-1 min-h-0 text-xs lg:text-base">
      <div class="w-full h-full overflow-y-scroll" ref="container">
        <div v-if="results.length > 0" class="space-y-2">
          <div
            class="
              flex
              items-center
              hover:bg-white-005
              rounded
              w-full
              h-10
              cursor-pointer
            "
            v-for="(item, index) in results"
            :key="index"
          >
            <div style="width: 9%" class="pl-1 lg:pl-2">{{ index + 1 }}</div>

            <div style="width: 40%" class="flex items-center pl-2">
              <UiImg
                class="w-8 h-8 rounded-full overflow-hidden mr-2"
                :src="item.daoLogo"
              ></UiImg>
              <router-link
                :to="`/dao/${item.daoPath}`"
                class="
                  font-bold
                  text-xs
                  lg:text-base
                  line-clamp-1
                  overflow-ellipsis
                  w-20
                  md:w-28
                "
                >{{ item.daoName }}</router-link
              >
            </div>
            <div style="width: 19%" class="pl-0 lg:pl-2 text-center">
              {{ formatVal(item.proposals, { omit: true, bit: 0 }) }}
            </div>
            <div style="width: 16%" class="pr-2 text-right">
              {{ formatVal(item.voters, { omit: true, bit: 0 }) }}
            </div>
            <div style="width: 16%" class="pr-2 text-right">
              {{ formatVal(item.votes, { omit: true, bit: 0 }) }}
            </div>
          </div>
        </div>
        <div v-if="loading" class="flex justify-center items-center h-10">
          <Spin></Spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getHomeGovernanceDaoRank } from '@/api/dao';
import { useReqPages } from '@/hooks';
import { onMounted, ref, inject, reactive, watch } from 'vue';
import Spin from '@/components/Spin.vue';
import UiImg from '@/components/UiImg.vue';
import { useInfiniteScroll } from '@vueuse/core';
import { homeChains, homeTypes } from './constant';
import Sort from '@/components/Sort.vue';
import { withThrottling } from '@/utils/with';
import { formatVal } from '@/utils';

const container = ref(null);
const homeState = inject('homeState');

const state = reactive({
  sortValue: [0, -1, -1],
});

const sortKey = ['proposals', 'voters', 'votes'];
const { loadRest, loadNext, loading, results } = useReqPages(
  async (page, cancel) => {
    const index = state.sortValue.findIndex((x) => x != -1);

    const res = await getHomeGovernanceDaoRank(
      homeTypes[homeState.selectedType].value,
      homeChains[homeState.selectedChain].value,
      page,
      {
        page,
        orderItem: sortKey[index],
        orderType: state.sortValue[index] != 1 ? 'desc' : 'asc',
      },
      cancel,
    );

    /* TODO */
    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

useInfiniteScroll(container, withThrottling(loadNext), {
  distance: 44,
});

watch(
  () =>
    JSON.stringify(state.sortValue) +
    homeState.selectedType +
    homeState.selectedChain,
  () => {
    loadRest(true);
  },
);

onMounted(loadRest);
</script>

<style lang="scss" scoped></style>
